module.exports = __webpack_public_path__ + "img/icon.b6f508ac.png";